/* eslint-disable import/no-named-as-default */
/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Typography from '@mui/material/Typography';
import armTheme from "../styles/armTheme";

// Import logo
import logo from "../assets/logo_dark.png";

const Container = styled("div")(({ theme }) => ({
  marginTop: "15%",
  marginBottom: "32px",
  marginLeft: "15px",
  marginRight: "15px",
  [theme.breakpoints.up("sm")]: {
    marginTop: "5%",
  },
}));

const BannerLink = styled(Link)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  textDecoration: "none",
  margin: "0 auto 0px auto",
  width: "290px",
});

const LogoImg = styled("img")({
  height: "50px",
  width: "84.13px",
  marginRight: "8px",
});

const LogoText = styled(Typography)({
  color: armTheme.colours.primary.main,
  fontFamily: "Black Ops One, Roboto",
});

const titleSx = { fontWeight: 500 };
const subtitleSx = {
  color: armTheme.colours.faded.main,
  fontWeight: 500,
};

// States to apply Style A
const styleAStates = ["signIn", "signUp"];

function Banner({authState}) {
  return (
    <Container>
      <BannerLink to="/" color="inherit">
        <LogoImg src={logo} alt="Logo" />
        <LogoText variant="h4" component="h1">Armalytics</LogoText>
      </BannerLink>
      <div style={{ marginTop: "24px" }}>
        <div style={{ textAlign: "center", maxWidth: "500px", margin: "0 auto" }}>
          <Typography sx={titleSx} variant="h5" component="h2" gutterBottom>Explore Canada&apos;s Firearms Reference Table</Typography>
          {styleAStates.includes(authState) && (
              <Typography variant="subtitle1" component="h3" sx={subtitleSx} gutterBottom>Sign-up and get full access to information on over 40,000 firearms and their variants.</Typography>
            )
          }
        </div>
      </div>
    </Container>
  );
}

Banner.propTypes = {
  authState: PropTypes.string,
};

export default Banner;
